// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#smsRecord .yto-box[data-v-2b7c171c] {\n  padding: 20px 0 0 0;\n}\n#smsRecord .yto-box .data-picker .el-date-editor--daterange.el-input__inner[data-v-2b7c171c] {\n    width: 220px;\n}\n#smsRecord .btn-r[data-v-2b7c171c] {\n  position: absolute;\n  right: 95px;\n  width: auto !important;\n}\n", ""]);
// Exports
module.exports = exports;
